query allUltimatePlayers(
  $first: Int,
  $offset: Int,
  $filter: UltimatePlayerFilter,
  ) {
  players: allUltimatePlayers(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      playerMappings: ultimatePlayerMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
          playerIndex
          playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
            nodes {
              discriminator
              team: ultimateTeamMapping { 
                extRef
              }
            }
          }
        }
      }
      name
      source
      playerId
      playerIndex
    }
    totalCount
  }
}
